/**
 * Клиентская копия функции суммы прописью — для мгновенного превью.
 * Серверная версия — в server/src/services/wordify.ts (источник истины).
 */

const UNITS_MALE = ['', 'один', 'два', 'три', 'четыре', 'пять', 'шесть', 'семь', 'восемь', 'девять'];
const UNITS_FEMALE = ['', 'одна', 'две', 'три', 'четыре', 'пять', 'шесть', 'семь', 'восемь', 'девять'];
const TEENS = ['десять', 'одиннадцать', 'двенадцать', 'тринадцать', 'четырнадцать', 'пятнадцать', 'шестнадцать', 'семнадцать', 'восемнадцать', 'девятнадцать'];
const TENS = ['', '', 'двадцать', 'тридцать', 'сорок', 'пятьдесят', 'шестьдесят', 'семьдесят', 'восемьдесят', 'девяносто'];
const HUNDREDS = ['', 'сто', 'двести', 'триста', 'четыреста', 'пятьсот', 'шестьсот', 'семьсот', 'восемьсот', 'девятьсот'];

function triad(n: number, female: boolean): string {
  if (!n) return '';
  const parts: string[] = [];
  const h = Math.floor(n / 100);
  const r = n % 100;
  if (h) parts.push(HUNDREDS[h]!);
  if (r >= 10 && r < 20) parts.push(TEENS[r - 10]!);
  else {
    const t = Math.floor(r / 10);
    const u = r % 10;
    if (t) parts.push(TENS[t]!);
    if (u) parts.push(female ? UNITS_FEMALE[u]! : UNITS_MALE[u]!);
  }
  return parts.join(' ');
}

function plural(n: number, forms: [string, string, string]): string {
  const m10 = n % 10;
  const m100 = n % 100;
  if (m100 >= 11 && m100 <= 14) return forms[2];
  if (m10 === 1) return forms[0];
  if (m10 >= 2 && m10 <= 4) return forms[1];
  return forms[2];
}

function integerToWords(n: number): string {
  if (n === 0) return 'ноль';
  const ths = Math.floor(n / 1000);
  const units = n % 1000;
  const parts: string[] = [];
  if (ths) {
    parts.push(triad(ths, true));
    parts.push(plural(ths, ['тысяча', 'тысячи', 'тысяч']));
  }
  if (units) parts.push(triad(units, false));
  return parts.filter(Boolean).join(' ');
}

export function rubleAmountToWords(amount: number): string {
  if (!Number.isFinite(amount) || amount < 0) return '';
  const rub = Math.floor(amount);
  const kop = Math.round((amount - rub) * 100);
  const rubWords = integerToWords(rub);
  const head = rubWords.charAt(0).toUpperCase() + rubWords.slice(1);
  const kopPart = kop === 0
    ? 'ноль копеек'
    : `${kop.toString().padStart(2, '0')} ${plural(kop, ['копейка', 'копейки', 'копеек'])}`;
  return `${head} ${plural(rub, ['рубль', 'рубля', 'рублей'])} ${kopPart}`;
}
